module.exports = __webpack_public_path__ + "static/img/5.42b68b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/sp/5.png
// module id = ssMW
// module chunks = 0